import { useParams } from "react-router";
import { useLocation } from "react-router-dom";
import { getURLParams, URLParams } from "../helpers/get-params";

export const useUrlParams = () => {
  const urlParams = useParams<URLParams>();
  const query = new URLSearchParams(useLocation().search);
  return getURLParams(urlParams, query.get.bind(query));
};
